export default __webpack_public_path__ + "static/media/IMG_5587.fae22757.jpg";